import {type PersonnelOverviewEntity} from './types/PersonnelOverviewEntity';
import {useSessionBoolean} from './useSessionBoolean';

const SESSION_KEY_PREFIX = 'personnel-overview-all-branches';

export function useHasUserSelectedAllBranches(entity: PersonnelOverviewEntity) {
  return useSessionBoolean(`${SESSION_KEY_PREFIX}:${entity}`);
}
